import React from 'react';

const CustomSection = ({ section = {}, primaryColor = '#1e3a8a' }) => {
  const { title = 'Custom Section', type = 'text', content = '', items = [] } = section;

  if (type === 'assessment_table') {
    return (
      <div style={{ marginBottom: '16px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '12px 14px' }}>
        <h4 style={{ margin: '0 0 8px 0', fontSize: '11px', fontWeight: '700', color: primaryColor, textTransform: 'uppercase' }}>
          {title}
        </h4>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '10.5px' }}>
          <thead>
            <tr style={{ background: primaryColor, color: '#fff' }}>
              <th style={{ padding: '5px 8px', textAlign: 'left' }}>Activity / Area</th>
              <th style={{ padding: '5px 8px', textAlign: 'center', width: '30%' }}>Grade / Rating</th>
            </tr>
          </thead>
          <tbody>
            {items.map((row, idx) => (
              <tr key={idx} style={{ borderBottom: '1px solid #e2e8f0', background: idx % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
                <td style={{ padding: '6px 8px', fontWeight: '600' }}>{row.activity || '—'}</td>
                <td style={{ padding: '6px 8px', textAlign: 'center', fontWeight: '700', color: primaryColor }}>{row.grade || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  if (type === 'key_value') {
    return (
      <div style={{ marginBottom: '16px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '10px 12px' }}>
        <h4 style={{ margin: '0 0 6px 0', fontSize: '11px', fontWeight: '700', color: primaryColor, textTransform: 'uppercase' }}>
          {title}
        </h4>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px', fontSize: '10.5px' }}>
          {items.map((item, idx) => (
            <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 8px', background: '#fff', border: '1px solid #e2e8f0', borderRadius: '4px' }}>
              <span style={{ fontWeight: '600', color: '#64748b' }}>{item.key}:</span>
              <span style={{ fontWeight: '700', color: '#0f172a' }}>{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (type === 'remarks') {
    return (
      <div style={{ marginBottom: '16px', border: '1px solid #cbd5e1', borderRadius: '6px', padding: '8px 12px', background: '#f8fafc' }}>
        <strong style={{ color: primaryColor, display: 'block', marginBottom: '4px', fontSize: '11px', textTransform: 'uppercase' }}>
          {title}:
        </strong>
        <span style={{ fontStyle: 'italic', color: '#334155', fontSize: '10.5px' }}>
          {content || 'Additional institutional observation.'}
        </span>
      </div>
    );
  }

  return (
    <div style={{ marginBottom: '16px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '10px 12px', fontSize: '10.5px' }}>
      <h4 style={{ margin: '0 0 4px 0', fontSize: '11px', fontWeight: '700', color: primaryColor, textTransform: 'uppercase' }}>
        {title}
      </h4>
      <div style={{ color: '#334155', lineHeight: '1.4' }}>
        {content || 'Custom institutional notification text or policy details.'}
      </div>
    </div>
  );
};

export default CustomSection;
